// Turks (tr-TR), kioskWeather: zelfde vorm als kioskWeather.nl.ts. Zelfde woorden als in
// weatherPrayer.tr.ts (weatherPrayer.test.ts bewaakt dat). Nooit een woord over gebed.
export const kioskWeatherTr = {
    title: 'Hava',
    open: 'Hava: {feel}. Daha fazlası için dokun.',
    stale: 'Hava şu an bilinmiyor',
    today: 'Bugün',
    tomorrow: 'Yarın',
    close: 'Kapat',
    feel: { cold: 'soğuk', chilly: 'serin', mild: 'güzel', warm: 'sıcak', hot: 'çok sıcak' },
    itemLabels: {
        thick_coat: 'Kalın mont',
        coat: 'Mont',
        sweater: 'Kazak',
        raincoat: 'Yağmurluk',
        boots: 'Çizme',
        hat_gloves: 'Bere ve eldiven',
        umbrella: 'Şemsiye',
        sunscreen: 'Güneş kremi',
        sun_hat: 'Şapkanı tak',
        water_bottle: 'Su şişesi',
        shorts: 'Şort',
    },
    day: {
        today: 'Bugün hava böyle',
        tomorrow: 'Yarın hava böyle',
        temp: 'Ne kadar sıcak?',
        tempValue: '{min} ile {max} derece arası',
        feels: 'Hava {feel}',
        rain: 'Yağmur',
        rainWords: {
            dry: 'Hava kuru kalıyor',
            small: 'Belki küçük bir sağanak',
            likely: 'Yağmur yağabilir',
            wet: 'Yağmur yağacak',
        },
        rainWhen: '{from} ile {until} arası',
        wind: 'Rüzgâr',
        windWords: {
            calm: 'Neredeyse hiç rüzgâr yok',
            light: 'Biraz rüzgâr var',
            fresh: 'Epey rüzgârlı',
            strong: 'Sert rüzgâr',
            very_strong: 'Çok sert rüzgâr',
        },
        windForce: 'Rüzgâr kuvveti {bft}',
        sun: 'Güneş',
        sunrise: 'Doğuş {time}',
        sunset: 'Batış {time}',
        uvWords: {
            moderate: 'Güneş güçlü. Uzun süre dışarıda mısın? O zaman krem sür.',
            high: 'Güneş çok güçlü. Krem sür ve şapkanı tak.',
        },
        course: 'Gün nasıl geçecek?',
        back: 'Geri',
        now: 'Şimdi',
    },
};
//# sourceMappingURL=kioskWeather.tr.js.map